import * as React from 'react'

import { i18nKeyPrefix } from 'main/components/school/i18n'
import { SchoolPage_availabilitySurvey as ISurvey } from 'main/pages/School/gql'
import { palette } from 'main/ui'
import { formatAge } from 'main/util/age'
import { TFunction, useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import Status from '../../../pages/Dashboard/pages/Home/Content/Hero/AvailabilityModal/steps/Start/Content/Status'
import { statusFromParams } from '../../../pages/Dashboard/pages/Home/Content/Hero/AvailabilityModal/steps/Start/Content/utils'
import { Container } from './AvailabilityBadge.styles'
const PRE = `${i18nKeyPrefix}-AVAILABILITY-BADGE`

interface IProps {
  compact: boolean
  availabilitySurvey: ISurvey | null
  eli: boolean
}

export default function AvailabilityBadge(props: IProps) {
  const { availabilitySurvey, eli } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (!availabilitySurvey) return null
  const ageRangeText = formattedAggregatedAgeRange(availabilitySurvey, t)
  const params = toParams(availabilitySurvey)
  const textAvailability = formattedTextAvailabilityUpdate(availabilitySurvey, params, eli, t)

  return (
    <Container
      style={{ backgroundColor: params.isEnrolling && params.isOpen ? palette.cosmicLatte : '' }}
    >
      <Status
        status={statusFromParams(params)}
        ageRangeText={ageRangeText}
        textAvailability={textAvailability}
      />
    </Container>
  )
}

function toParams(survey: ISurvey | null) {
  if (survey) {
    const { aggregatedOpenSpotsCount, isOpen } = survey
    const isEnrolling = aggregatedOpenSpotsCount ? aggregatedOpenSpotsCount > 0 : false

    return {
      isEnrolling,
      isOpen: !!isOpen,
    }
  }

  return { isOpen: true, isEnrolling: true }
}

function formattedAggregatedAgeRange(survey: ISurvey, t: TFunction): string | null {
  const { aggregatedAgeRangeMax: max, aggregatedAgeRangeMin: min } = survey

  if (max === null || min === null) return null

  const minAge = formatAge(min)
  const maxAge = formatAge(max)

  return t(`${PRE}-RANGE`, { minAge, maxAge })
}

function formattedTextAvailabilityUpdate(
  survey: ISurvey,
  params: any,
  eli: boolean,
  t: TFunction,
): string | null {
  if (
    survey.isOpen &&
    survey.isStale !== null &&
    !survey.isStale &&
    params.isEnrolling &&
    survey.lastUpdatedOn
  ) {
    const lastUpdatedDate = new Date(survey.lastUpdatedOn)
    const currentDate = new Date()
    let days = Math.floor((currentDate.getTime() - lastUpdatedDate.getTime()) / (1000 * 3600 * 24))
    if (eli) {
      if (days > 90) {
        return null
      }
      const date = lastUpdatedDate.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      })
      return t(`${PRE}-UPDATED-ON-DATE`, { date })
    }
    days = days <= 60 ? 60 : 90
    return t(`${PRE}-UPDATED-DAYS-BEFORE`, { days })
  }
  return null
}
